import { Avatar, Flex, Img } from '@chakra-ui/react'
import { FaPeopleArrows, FaUserCheck, FaUsers } from 'react-icons/fa'
import { iCardAvaliacaoResponse } from '../..'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'
const IconeOutros = 'https://sigah.blob.core.windows.net/assets/front/IconeOutrosAzul.svg'
const IconeLider = 'https://sigah.blob.core.windows.net/assets/front/IconeLiderAzul.svg'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  isForm: boolean
  avaliacoes: iCardAvaliacaoResponse[]
}

export const ModalAvaliacoes: React.FC<props> = ({ isOpen, onRequestClose, avaliacoes, isForm }) => {
  function getIcon(tipo: number): any {
    switch (tipo) {
      case 0: return <FaUserCheck size={22} style={{ marginRight: '.25rem' }} />
      case 2: return <FaPeopleArrows size={22} style={{ marginRight: '.25rem' }} />
      case 1: return <Img width={22} height={22} marginRight={'.25rem'} color={'var(--Blue)'} src={IconeLider} />
      case 3: return <FaUsers size={22} style={{ marginRight: '.25rem' }} />
      case 4: return <img src={IconeOutros} width={22} height={22} style={{ marginRight: '.25rem' }}/>
      case 6: return <FaPeopleArrows size={22} style={{ marginRight: '.25rem' }} />
      default: return <FaUserCheck size={22} style={{ marginRight: '.25rem' }} />
    }
  }

  function getName(tipo: number): any {
    switch (tipo) {
      case 0:
        return isForm ? 'Participante' : 'Autoavaliação'
      case 2:
        return 'Pares'
      case 1:
        return 'Gestor'
      case 3:
        return 'Liderados'
      case 4:
        return 'Outros'
      case 6:
        return 'Alta liderança'
      default:
        return ''
    }
  }

  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo={isForm ? 'Status por participante' : 'Status por avaliação'}
            Width='62rem'
        >
            <Flex flexDir={'column'} gap={'.875rem'} px={'1rem'} pt={'1.25rem'} maxH={'85vh'} overflowY={'auto'}>
              {avaliacoes.map(e => {
                return <Flex px={'2rem'} border={'1px solid var(--c6)'} py={'1rem'} bg={e.encerrada ? 'var(--Green2OpacoBg)' : 'var(--RedOpacoBg)'}>
                  <Flex gap={'.5rem'} alignItems={'center'} w={'40%'} borderRight={'1px solid var(--c6)'} pr={'1rem'}>
                    <Avatar src={e.colaborador?.avatar} size={'sm'}/>
                    <Flex flexDir={'column'} lineHeight={'16px'} fontSize={'14px'}>
                      <strong>{e.colaborador?.nome}</strong><strong style={{ color: e.encerrada ? 'var(--Green2)' : 'var(--Red)' }}>{e.encerrada ? 'Concluída' : 'Pendente'}</strong>
                    </Flex>
                  </Flex>
                  <Flex w={'60%'}>
                    <Flex gap={'1rem'} justifyContent={'start'} color={'var(--Azul)'} flexWrap='wrap' width={'100%'} px={'1.25rem'}>
                        {
                            e.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).map((eixo, i) => {
                              return (
                                <Flex flexDir={'column'} fontSize={'.75rem'} alignItems={'center'} opacity={(eixo.respondidos === 0 && e.total === 0) ? '.5' : ''} cursor={(eixo.respondidos === 0 && e.total === 0) ? 'not-allowed' : ''}borderRight={e.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).length !== (i + 1) ? '2px dashed var(--AzulOpaco)' : ''} p={e.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).length !== (i + 1) ? '0 1.25rem 0 .25rem' : '0 0 0 .75rem'} pl={i === 0 ? '0' : undefined}>
                                    <Flex alignItems={'center'} gap={'.325rem'}>
                                        {getIcon(eixo.tipoAvaliador)}
                                        <strong>{eixo.respondidos}/{eixo.total}</strong>
                                    </Flex>
                                    <strong style={{ color: 'black' }}>{getName(eixo.tipoAvaliador)}</strong>
                                </Flex>
                              )
                            })
                        }
                    </Flex>
                  </Flex>
                </Flex>
              })}
            </Flex>
            <Flex justifyContent={'center'} gap={'1rem'} p={'1rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Fechar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
